var map = {
	"./SlideShow1.png": 352,
	"./SlideShow10.png": 2056,
	"./SlideShow11.png": 4470,
	"./SlideShow12.png": 655,
	"./SlideShow13.png": 2184,
	"./SlideShow14.png": 909,
	"./SlideShow15.png": 307,
	"./SlideShow16.png": 4175,
	"./SlideShow17.png": 5882,
	"./SlideShow18.png": 2151,
	"./SlideShow19.png": 1161,
	"./SlideShow2.png": 4267,
	"./SlideShow20.png": 7528,
	"./SlideShow3.png": 6121,
	"./SlideShow4.png": 6004,
	"./SlideShow5.png": 5954,
	"./SlideShow6.png": 9881,
	"./SlideShow7.png": 9021,
	"./SlideShow8.png": 665,
	"./SlideShow9.png": 8311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1665;